import React, { useState, useEffect, Fragment } from "react";
import Container from "@mui/material/Container";
import fetchData from "verticales/FetchData";
import { Card, Box, Button, Stack, TextField, Autocomplete, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import AppLoading from "verticales/AppLoading.tsx";
import ViewAlertResizes from "./ViewAlertResizes";

var cuentaSelectResize = "none";
var opcionesInstances = [];
const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
var opcionesInstances: Array<{ title: string }> = [];
const context = "ec2-aws-resize";

// Función para filtrar opciones que no comiencen con M7i o R7i
const filterInstanceOptions = (options) => {
  return options.filter(
    (option) =>
      !option.value.toLowerCase().startsWith("m7i") && !option.value.toLowerCase().startsWith("r7i")
  );
};

const ViewNewEdit = (props: any) => {
  const [instanceId, setInstanceId] = useState(
    props.row.original ? props.row.original.instance_id : ""
  );
  const [instancia, setInstance] = useState(
    props.row.original ? props.row.original.instance_name : ""
  );
  const [instanceBase, setInstanceBase] = useState(
    props.row.original ? props.row.original.instance_type_base : ""
  );
  const [instanceResize, setInstanceResize] = useState(
    props.row.original ? props.row.original.instance_type_resize : ""
  );
  const [instanceBaseRespaldo, setInstanceBaseRespaldo] = useState(
    props.row.original ? props.row.original.instance_type_base_respaldo : ""
  );
  const [instanceResizeRespaldo, setInstanceResizeRespaldo] = useState(
    props.row.original ? props.row.original.instance_type_resize_respaldo : ""
  );
  const [horaBase, setHoraBase] = useState(props.row.original ? props.row.original.hora_base : 0);
  const [horaResize, setHoraResize] = useState(
    props.row.original ? props.row.original.hora_resize : 0
  );
  const [dias, setDias] = useState(props.row.original ? props.row.original.dias : "");
  const [comentario, setComentario] = useState(
    props.row.original ? props.row.original.comentario : ""
  );
  const [feActualizacion, setFeActualizacion] = useState(
    props.row.original ? props.row.original.fecha_creacion : ""
  );
  const [feCrecion, setFeCrecion] = useState(
    props.row.original ? props.row.original.fecha_actualizacion : ""
  );
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({
    instanceId: false,
    instanceBase: false,
    instanceResize: false,
    instanceBaseRespaldo: false,
    instanceResizeRespaldo: false,
    horaBase: false,
    horaResize: false,
    dias: false,
  });

  const [errorInstanceBaseRespaldo, setErrorInstanceBaseRespaldo] = useState(false);
  const [errorInstanceResizeRespaldo, setErrorInstanceResizeRespaldo] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  if (opcionesInstances.length == 0 || props.cuentaSelect != cuentaSelectResize) {
    opcionesInstances = [];
    for (let objInsEc2 of props.dataInstance) {
      opcionesInstances.push({ title: objInsEc2.title });
    }
    cuentaSelectResize = props.cuentaSelect;
  }

  const handleAccept = async () => {
    // Validar campos requeridos
    const newErrors = {
      instanceId: instanceId === "",
      instanceBase: instanceBase === "",
      instanceResize: instanceResize === "",
      instanceBaseRespaldo: instanceBaseRespaldo === "",
      instanceResizeRespaldo: instanceResizeRespaldo === "",
      horaBase: horaBase === -1,
      horaResize: horaResize === -1,
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      setErrorMessage("Los campos son requeridos.");
      setErrors(newErrors);
      return;
    } else {
      setErrorMessage("");
      setErrors({});
    }

    if (horaBase === horaResize) {
      setErrorMessage("La hora base y resize no pueden ser iguales.");
      return;
    } else {
      setErrorMessage("");
    }

    const isValid = validateDias(dias);
    if (!isValid) {
      setErrors((prevErrors) => ({ ...prevErrors, dias: "Formato inválido. Debe ser [1,2,3,4]" }));
      setErrorMessage("");
      return;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, dias: "" }));
      setErrorMessage("");
    }

    const isBaseRespaldoInvalid =
      instanceBaseRespaldo.toLowerCase().startsWith("m7i") ||
      instanceBaseRespaldo.toLowerCase().startsWith("r7i");
    const isResizeRespaldoInvalid =
      instanceResizeRespaldo.toLowerCase().startsWith("m7i") ||
      instanceResizeRespaldo.toLowerCase().startsWith("r7i");

    setErrorInstanceBaseRespaldo(isBaseRespaldoInvalid);
    setErrorInstanceResizeRespaldo(isResizeRespaldoInvalid);

    if (isBaseRespaldoInvalid || isResizeRespaldoInvalid) {
      setErrorMessage("No se permiten familias que sean M7i o R7i en respaldo.");
      return;
    } else {
      setErrorMessage("");
    }

    // Validar si la instancia existe en procesos de apagado
    try {
      const payload = {
        action: "Validate-ec2",
        instanceId,
      };

      const response = await fetchData(
        "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/",
        "ec2-aws-resize",
        payload
      );

      if (response && response.exists) {
        // Si existe, mostrar la alerta
        setOpenAlert(true);
      } else {
        // Si no existe, guardar directamente
        saveRecord();
      }
    } catch (error) {
      console.error("Error al validar la instancia:", error);
      setErrorMessage("Error al verificar la instancia. Intente nuevamente.");
    }
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleValidationResult = () => {
    // Solo se llama cuando el usuario acepta la advertencia
    // saveRecord();
  };

  const saveRecord = async () => {
    setBlocking(true);
    const params = {
      action: props.row.original ? "UPDATE" : "INSERT",
      object: {
        instanceId,
        instancia,
        instanceBase,
        instanceResize,
        instanceBaseRespaldo,
        instanceResizeRespaldo,
        horaBase,
        horaResize,
        dias,
        comentario,
        cuenta: props.cuentaSelect,
        feActualizacion: new Date(),
        feCrecion: props.row.original ? feCrecion : new Date(),
        id: props.row.original ? props.row.original.id : -1,
      },
    };

    try {
      const resp = await fetchData(url, context, params);
      console.log("result", resp);
      props.handleCloseModal(true);
    } catch (error) {
      console.error("Error al guardar el registro:", error);
    } finally {
      setBlocking(false);
    }
  };

  const validateDias = (value: string) => {
    const regex = /^\[([0-6](,[0-6])*)?\]$/;
    const isValidFormat = regex.test(value);
    if (!isValidFormat || value === "[]") return false;

    const numbers = value.slice(1, -1).split(",").map(Number);
    const uniqueNumbers = new Set(numbers);
    return numbers.length === uniqueNumbers.size;
  };

  const handleBlur = () => {
    const isValid = validateDias(dias);
    if (!isValid) {
      setErrors({ ...errors, dias: true });
    }
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <MDTypography variant="h4" color="white">
                  Instancia
                </MDTypography>
                <IconButton
                  aria-label="close"
                  onClick={() => props.handleCloseModal(false)}
                  sx={(theme) => ({
                    color: theme.palette.common.white,
                  })}
                >
                  <CloseIcon />
                </IconButton>
              </MDBox>
              {blocking ? (
                <AppLoading titleCustom={"Ec2-Aws-Resize"} />
              ) : (
                <Box
                  component="form"
                  sx={{ "& .MuiTextField-root": { m: 1 }, width: 480, textAlign: "center" }}
                  noValidate
                  autoComplete="off"
                >
                  <Grid maxWidth="sm">
                    <Autocomplete
                      disablePortal
                      style={{ width: 460 }}
                      options={opcionesInstances.map((option) => option.title)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="instancia ec2"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-instance",
                          }}
                          error={errors.instanceId}
                        />
                      )}
                      onChange={(event: any, newValue: string | null) => {
                        let objInstance = props.dataInstance.find(
                          (option) => option.title === newValue
                        );
                        if (objInstance) {
                          setInstanceId(objInstance.instance_id);
                          setInstance(objInstance.instance_name);
                          setInstanceBase(objInstance.instance_type);
                          setFeActualizacion("");
                        }
                      }}
                    />
                  </Grid>

                  <TextField
                    style={{ width: 223 }}
                    value={instanceId}
                    disabled
                    id="instance-id"
                    label="Instance Id"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setInstanceId(event.target.value);
                    }}
                  />
                  <TextField
                    style={{ width: 223 }}
                    value={instancia}
                    disabled
                    id="instancia"
                    label="Instancia"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setInstance(event.target.value);
                    }}
                  />

                  <Stack spacing={{ xs: 2, sm: 2 }} direction="row" useFlexGap flexWrap="wrap">
                    <Autocomplete
                      value={
                        instanceOptions.find((option) => option.value === instanceBase) || null
                      }
                      style={{ width: 223 }}
                      size="small"
                      disablePortal
                      options={instanceOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Instance Base:"
                          required
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-instance-base",
                          }}
                          error={errors.instanceBase}
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setInstanceBase(newValue.value);
                        } else {
                          setInstanceBase("");
                        }
                      }}
                    />

                    <Autocomplete
                      value={instanceOptions.find((Option) => Option.value === instanceResize)}
                      style={{ width: 223 }}
                      size="small"
                      disablePortal
                      options={instanceOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          id="instance-resize"
                          label="Instance Resize"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-instance-resize",
                          }}
                          error={errors.instanceResize}
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setInstanceResize(newValue.value);
                        } else {
                          setInstanceResize("");
                        }
                      }}
                    />
                  </Stack>
                  <Stack spacing={{ xs: 2, sm: 2 }} direction="row" useFlexGap flexWrap="wrap">
                    <Autocomplete
                      value={instanceOptions.find(
                        (Option) => Option.value === instanceBaseRespaldo
                      )}
                      style={{ width: 223 }}
                      size="small"
                      disablePortal
                      options={filterInstanceOptions(instanceOptions)}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          id="instance-base-respaldo"
                          label="Instance Base Respaldo"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-instance-base-respaldo",
                          }}
                          error={errorInstanceBaseRespaldo || errors.instanceBaseRespaldo}
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setInstanceBaseRespaldo(newValue.value);
                          setErrorInstanceBaseRespaldo(false);
                        } else {
                          setInstanceBaseRespaldo("");
                        }
                      }}
                    />
                    <Autocomplete
                      value={instanceOptions.find(
                        (Option) => Option.value === instanceResizeRespaldo
                      )}
                      style={{ width: 223 }}
                      size="small"
                      disablePortal
                      options={filterInstanceOptions(instanceOptions)}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          id="instance-resize-respaldo"
                          label="Instance Resize Respaldo"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-instance-resize-respaldo",
                          }}
                          error={errorInstanceResizeRespaldo || errors.instanceResizeRespaldo}
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setInstanceResizeRespaldo(newValue.value);
                          setErrorInstanceResizeRespaldo(false);
                        } else {
                          setInstanceResizeRespaldo("");
                        }
                      }}
                    />
                  </Stack>
                  <TextField
                    size="small"
                    value={horaBase}
                    type="number"
                    required
                    id="hora-base"
                    label="Hora Base"
                    style={{ width: 223 }}
                    inputProps={{
                      min: 0,
                      max: 23,
                      step: 1,
                      onChange: (event) => {
                        let value = parseInt(event.target.value);
                        if (!isNaN(value)) {
                          value = Math.min(Math.max(value, 0), 23);
                        } else {
                          value = 0;
                        }
                        setHoraBase(value);
                      },
                    }}
                    error={errors.horaBase}
                  />
                  <TextField
                    size="small"
                    value={horaResize}
                    type="number"
                    required
                    id="hora-resize"
                    label="Hora Resize"
                    style={{ width: 223 }}
                    inputProps={{
                      min: 0,
                      max: 24,
                      step: 1,
                      onChange: (event) => {
                        let value = parseInt(event.target.value);
                        if (!isNaN(value)) {
                          value = Math.min(Math.max(value, 0), 23);
                        } else {
                          value = 0;
                        }
                        setHoraResize(value);
                      },
                    }}
                    error={errors.horaResize}
                  />
                  <TextField
                    style={{ width: 223 }}
                    value={dias}
                    required
                    id="dias"
                    label="Dias"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setDias(event.target.value);
                    }}
                    onBlur={handleBlur}
                    error={errors.dias}
                    helperText={errors.dias ? "Error. Debe ser [1,2,3,4,5,6,0]" : ""}
                  />
                  <TextField
                    style={{ width: 223 }}
                    value={comentario}
                    id="Comentario"
                    label="Comentario"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setComentario(event.target.value);
                    }}
                  />
                  <TextField
                    style={{ width: 223 }}
                    value={feActualizacion}
                    disabled
                    id="fe-actualizacion"
                    label="Fecha Actualizacion"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setFeActualizacion(event.target.value);
                    }}
                  />
                  <TextField
                    style={{ width: 223 }}
                    value={feCrecion}
                    disabled
                    id="fe-crecion"
                    label="Fecha Crecion"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setFeCrecion(event.target.value);
                    }}
                  />
                  <Stack justifyContent="right" direction="row" sx={{ p: 1 }}>
                    {errorMessage && (
                      <Typography color="error" variant="body2" sx={{ ml: 2 }}>
                        {errorMessage}
                      </Typography>
                    )}
                    <MDButton disableElevation onClick={props.handleCloseModal}>
                      <MDTypography>Cancelar</MDTypography>
                    </MDButton>
                    <ViewAlertResizes
                      instanceId={instanceId}
                      open={openAlert}
                      onClose={handleCloseAlert}
                      onValidationResult={handleValidationResult}
                    />
                    <MDButton disableElevation onClick={handleAccept}>
                      <MDTypography>Aceptar</MDTypography>
                    </MDButton>
                  </Stack>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

const instanceOptions = [
  { label: "t3.large -8GB 2CPU", value: "t3.large" },
  { label: "t3.xlarge -16GB 4CPU", value: "t3.xlarge" },
  { label: "t3.2xlarge-32GB 8CPU", value: "t3.2xlarge" },
  { label: "m6i.large- 8GB 2CPU", value: "m6i.large" },
  { label: "m6i.xlarge-16GB 4CPU", value: "m6i.xlarge" },
  { label: "m6i.2xlarge-32GB 8CPU", value: "m6i.2xlarge" },
  { label: "m6i.4xlarge-64GB 16CPU", value: "m6i.4xlarge" },
  { label: "m7a.large-8GB 2CPU", value: "m7a.large" },
  { label: "m7a.xlarge-16GB 4CPU", value: "m7a.xlarge" },
  { label: "m7a.2xlarge-32GB 8CPU", value: "m7a.2xlarge" },
  { label: "m7a.4xlarge-64GB 16CPU", value: "m7a.4xlarge" },
  { label: "m7i.large-8GB 2CPU", value: "m7i.large" },
  { label: "m7i.xlarge-16GB 4CPU", value: "m7i.xlarge" },
  { label: "m7i.2xlarge-32GB 8CPU", value: "m7i.2xlarge" },
  { label: "m7i.4xlarge-64GB 16CPU", value: "m7i.4xlarge" },
  { label: "m7i-flex.large-8GB 2CPU", value: "m7i-flex.large" },
  { label: "m7i-flex.xlarge-16GB 4CPU", value: "m7i-flex.xlarge" },
  { label: "m7i-flex.2xlarge-32GB 8CPU", value: "m7i-flex.2xlarge" },
  { label: "m7i-flex.4xlarge-64GB 16CPU", value: "m7i-flex.4xlarge" },
  { label: "r5a.large-16GB 2CPU", value: "r5a.large" },
  { label: "r5a.xlarge-32GB 4CPU", value: "r5a.xlarge" },
  { label: "r5a.2xlarge-64GB 8CPU", value: "r5a.2xlarge" },
  { label: "r5a.4xlarge-128GB 16CPU", value: "r5a.4xlarg" },
  { label: "r6i.xlarge-32GB 4CPU", value: "r6i.xlarge" },
  { label: "r6i.2xlarge-64GB 8CPU", value: "r6i.2xlarge" },
  { label: "r6i.4xlarge-128GB 16CPU", value: "r6i.4xlarge" },
  { label: "r7a.large-16GB 2CPU", value: "r7a.large" },
  { label: "r7a.xlarge-32GB 4CPU", value: "r7a.xlarge" },
  { label: "r7a.2xlarge-64GB 8CPU", value: "r7a.2xlarge" },
  { label: "r7a.4xlarge-128GB 16CPU", value: "r7a.4xlarge" },
  { label: "r7i.xlarge-32GB 4CPU", value: "r7i.xlarge" },
  { label: "r7i.2xlarge-64GB 8CPU", value: "r7i.2xlarge" },
  { label: "r7i.4xlarge-128GB 16CPU", value: "r7i.4xlarge" },
  { label: "r8i.large-32GB 4CPU", value: "r8i.large" },
  { label: "r8i.xlarge-32GB 4CPU", value: "r8i.xlarge" },
  { label: "r8i.2xlarge-64GB 8CPU", value: "r8i.2xlarge" },
  { label: "r8i.4xlarge-128GB 16CPU", value: "r8i.4xlarge" },
  { label: "m8i.large-8GB 2CPU", value: "m8i.large" },
  { label: "m8i.xlarge-16GB 4CPU", value: "m8i.xlarge" },
  { label: "m8i.2xlarge-32GB 8CPU", value: "m8i.2xlarge" },
  { label: "m8i.4xlarge-64GB 16CPU", value: "m8i.4xlarge" },
];

export default ViewNewEdit;
